/* eslint-disable no-unused-vars */
<template>
  <div>
    <b-button :title="'Habilitar edição de Tela'"
      v-if="user && user.Permissions && user.Permissions.editartelamonitoramento && user.Permissions.editartelamonitoramento.allowed && isReady && !editorMode" id='btLock' size="sm"
      @click="ChangeEditMode()">
      <b-icon class="lockIcon" icon="lock" aria-hidden="true"></b-icon>
    </b-button>

    <div v-if="editorMode && isReady">
      <div class="header-actions">
        <b-button
          v-if="user && user.Permissions && user.Permissions.editartelamonitoramento && user.Permissions.editartelamonitoramento.allowed"
          size="sm"
          class="monitor-btn"
          title="Editar cabeçalhos"
          @click="headerEditorMode = !headerEditorMode">
          <b-icon icon="pencil" aria-hidden="true"></b-icon>
        </b-button>
        <b-button
          size="sm"
          class="monitor-btn"
          title="Desabilitar edição de Tela"
          @click="ChangeEditMode()">
          <b-icon icon="unlock" aria-hidden="true"></b-icon>
        </b-button>
        <b-button
          v-if="user && user.Permissions && user.Permissions.editartelamonitoramento && user.Permissions.editartelamonitoramento.allowed"
          size="sm"
          class="monitor-btn ml-auto"
          title="Configurações dos Headers"
          @click="$bvModal.show('headerConfigModal')">
          <b-icon icon="gear" aria-hidden="true"></b-icon>
        </b-button>
      </div>

      <div v-if="headerEditorMode" class="header-row header-row--editing">
        <div
          v-for="(ghost, idx) in ghostHeaders"
          :key="idx"
          class="ghost-header"
          :class="{ 'ghost-header--real': !ghost.isGhost }"
          :style="ghostStyle(ghost.w)"
        >
          <div class="ghost-header-display" :class="indicatorHeaderClasses(ghost.areaName)">
            <indicator-header-card v-if="savedHeaderConfigOption === 'indicators' && ghost.areaName" :item="getLayoutItem(ghost.areaName)" />
            <template v-else>
              <span class="ghost-area-name">{{ ghost.areaName || headerDropdownPlaceholder }}</span>
              <span class="ghost-adherence ghost-adherence--right">{{ ghostAdherence(ghost.areaName) }}</span>
            </template>
          </div>
          <div class="ghost-header-controls">
            <select class="ghost-select" v-model="ghost.areaName" @change="onAreaChange(ghost)">
              <option value="">{{ headerDropdownPlaceholder }}</option>
              <option v-for="name in headerDropdownOptions" :key="name" :value="name">{{ name }}</option>
            </select>
            <select class="ghost-select ghost-select--cols" v-model="ghost.w" @change="onWidthChange(ghost, idx)">
              <option v-for="n in maxColsForGhost(idx)" :key="n" :value="n">{{ n }} col</option>
            </select>
            <b-button v-if="!ghost.isGhost" size="sm" variant="outline-danger" class="ghost-btn-remove" title="Remover cabeçalho" @click="removeGhost(idx)">
              <b-icon icon="trash" aria-hidden="true"></b-icon>
            </b-button>
          </div>
        </div>
      </div>

      <div v-else-if="previewHeaders.some(h => !h.isGhost)" class="header-row">
        <div
          v-for="(h, idx) in previewHeaders"
          :key="idx"
          :class="h.isGhost ? 'ghost-header ghost-header--spacer' : 'ghost-header ghost-header--real'"
          :style="ghostStyle(h.w)"
        >
          <div v-if="!h.isGhost" class="ghost-header-display" :class="indicatorHeaderClasses(h.areaName)">
            <indicator-header-card v-if="savedHeaderConfigOption === 'indicators' && h.areaName" :item="getLayoutItem(h.areaName)" />
            <template v-else>
              <span class="ghost-area-name">{{ h.areaName }}</span>
              <span class="ghost-adherence ghost-adherence--right">{{ ghostAdherence(h.areaName) }}</span>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="isReady && savedHeaders.some(h => !h.isGhost)" class="header-row">
      <div
        v-for="(h, idx) in savedHeaders"
        :key="idx"
        :class="h.isGhost ? 'ghost-header ghost-header--spacer' : 'ghost-header ghost-header--real'"
        :style="ghostStyle(h.w)"
      >
        <div v-if="!h.isGhost" class="ghost-header-display" :class="indicatorHeaderClasses(h.areaName)">
          <indicator-header-card v-if="savedHeaderConfigOption === 'indicators' && h.areaName" :item="getLayoutItem(h.areaName)" />
          <template v-else>
            <span class="ghost-area-name">{{ h.areaName }}</span>
            <span class="ghost-adherence ghost-adherence--right">{{ ghostAdherence(h.areaName) }}</span>
          </template>
        </div>
      </div>
    </div>

    <div v-if="isReady">
      <grid-layout :cols="colsNumber" :layout.sync="layout" :row-height="layout2.gridMonitoringConfiguration.rowHeight"
        :is-draggable="editorMode" :is-resizable="editorMode && layout2.gridMonitoringConfiguration.isResizable"
        :is-mirrored="layout2.gridMonitoringConfiguration.isMirrored"
        :vertical-compact="layout2.gridMonitoringConfiguration.verticalCompact"
        :margin="[layout2.gridMonitoringConfiguration.xMargin, layout2.gridMonitoringConfiguration.yMargin]"
        :use-css-transforms="layout2.gridMonitoringConfiguration.cssTransforms" :preventCollision="!editorMode"
        :responsive="layout2.gridMonitoringConfiguration.responsive" @click="click()">

        <grid-item v-for="item in layout" :static="item.staticCard" :key="item.i" :i="item.i" :x="item.x" :y="item.y"
          :w="item.w" :h="item.h" :minW="item.cardMinWidth" :minH="item.cardMinHeight">
          <MonitoringLayoutCard :item="item" :layout2="layout2" @sendSignalOpenModal="receive = $event" />
        </grid-item>
      </grid-layout>
    </div>

    <span v-else>
      <div class="waitTxt">{{ $t('aguardando-banco-de-dados') }}</div>
    </span>

    <b-modal id="headerConfigModal" title="Configurações dos Headers" hide-footer @hide="cancelHeaderConfig">
      <div class="header-config-body">
        <b-form-group label="Tipo de exibição nos cabeçalhos:">
          <b-form-radio v-model="headerConfigOption" value="areas">Áreas</b-form-radio>
          <b-form-radio v-model="headerConfigOption" value="indicators">Indicadores</b-form-radio>
        </b-form-group>
        <p v-if="headerConfigOption !== savedHeaderConfigOption" class="header-config-warning">
          Todos os headers atuais serão apagados ao salvar esta alteração.
        </p>
      </div>
      <div class="header-config-footer">
        <b-button variant="secondary" @click="cancelHeaderConfig">Cancelar</b-button>
        <b-button variant="danger" :disabled="headerConfigOption === savedHeaderConfigOption" @click="saveHeaderConfig">Salvar</b-button>
      </div>
    </b-modal>

    <b-modal id="UntratedOccurrences" size="xl" hide-footer>
      <div slot="modal-title" class="img-slot">
        <img style="width: 33px; height: 33px; margin-right: 10px" src="@/assets/circular138.png"
          alt="salvar_ocorrencia" />
        <label>{{ $t("untrated-occurrences") }}</label>
      </div>
      <ManageAllOccurrences :indicatorInfo="receive.item" :reloadOccFunct="loadGridMonitoring"
        :showActionResponsible="false" :showInfluencingParams="true"></ManageAllOccurrences>
    </b-modal>
  </div>
</template>

<script>

var task;
import VueGridLayout from 'vue-grid-layout';
import { urlMainAPI, defaultSuccess } from "@/global";
import { mapState } from "vuex";
import { rotationScreenMixin } from "../mixins/rotationScreenMixin"
import axios from "axios";
import ManageAllOccurrences from '../manageAllOccurrences/ManageAllOccurrences.vue';

import MonitoringLayoutCard from "./MonitoringLayoutCard.vue";
import IndicatorHeaderCard from "./IndicatorHeaderCard.vue";

export default {
  mixins: [rotationScreenMixin],
  components: {
    MonitoringLayoutCard,
    IndicatorHeaderCard,
    ManageAllOccurrences,
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
  },
  computed: {
    ...mapState(["msg", "user", "isOnlineRunning", "activeModel"]),
    footerOnlineMsg() {
      if (!this.isOnlineRunning || !this.activeModel) return null;
      return `${this.$t('onlineActive')} ${this.$t('model')}${this.activeModel}`;
    },
    savedHeaders() {
      const config = this.layout2 &&
        this.layout2.gridMonitoringConfiguration &&
        this.layout2.gridMonitoringConfiguration.areaHeadersConfig;
      if (!config) return [];
      try {
        const parsed = JSON.parse(config);
        if (parsed && !Array.isArray(parsed) && Array.isArray(parsed.items)) {
          return parsed.items;
        }
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    },
    headerDropdownOptions() {
      if (this.savedHeaderConfigOption === 'indicators') {
        return [...new Set(this.layout.map(i => i.indicatorName).filter(Boolean))].sort();
      }
      return this.allRootNames;
    },
    headerDropdownPlaceholder() {
      return this.savedHeaderConfigOption === 'indicators' ? '-- Indicador --' : '-- Área --';
    },
    previewHeaders() {
      const hasReal = this.ghostHeaders.some(g => !g.isGhost);
      return hasReal ? this.ghostHeaders : this.savedHeaders;
    },
  },
  watch: {
    $route(to) {
      this.unit = to.params.unit;
      this.editorMode = false;
      this.headerEditorMode = false;
      this.ghostHeaders = [];
      if (this.layout2 && this.layout2.gridMonitoringConfiguration) {
        this.layout2.gridMonitoringConfiguration.areaHeadersConfig = null;
      }
      this.$store.commit('setMonitoringEditorMode', false);
      clearTimeout(task);
      this.loadGridMonitoring();
    },

    receive() {
      this.$bvModal.show("UntratedOccurrences");
    },

    headerEditorMode(val) {
      if (val) {
        this.generateGhostHeaders();
        this.loadRootNames();
      }
    },
  },
  data() {
    return {
      colsNumber: { 'lg': 7, 'md': 4, 'sm': 3, 'xs': 2, 'xxs': 1 },
      receive: {},
      editorMode: false,
      headerEditorMode: false,
      ghostHeaders: [],
      allRootNames: [],
      unit: this.$route.params.unit,
      canShowFooter: true,
      isReady: false,
      footerBaseMsg: '',
      footerMsgIndex: 0,
      footerRotationInterval: null,
      reliability: {
        pgdi: false,
        a: 0,
        b: 0,
        c: 0,
        daily: 0,
        gridOn: true,
        a_name: 'A',
        b_name: 'B',
        c_name: 'C',
      },
      layout: [],
      layout2: {
        indicatorMonitoringGroup: {
          timestamp: "",
        },
        gridMonitoringConfiguration: {
          qtyColumns: 1,
          colNum: 8,
        },
      },
      gridId: null,
      minutesMonitoring: 0,
      rootStates: {},
      headerConfigOption: 'areas',
      savedHeaderConfigOption: 'areas'
    };
  },

  filters: {
    numberFormat(num) {

      if (num == "-9999" || num == "-9999,00") {
        return "0,00";
      }

      try {
        if (num.includes(",")) {
          num = num.replace(',', '.')
        }
        if (!isNaN(parseFloat(num))) {
          var numParsed = parseFloat(num);
          if (numParsed >= 100000 || numParsed <= -100000)
            return numParsed.toExponential(3)
          if (numParsed > 0 && numParsed < 1 || numParsed < 0 && numParsed > -1) {
            numParsed = numParsed.toFixed(4);
          } else {
            numParsed = numParsed.toFixed(2);
          }
          numParsed = numParsed.replace('.', ',').split(",")
          let v1 = numParsed[0]
          let v2 = numParsed[1]
          v1 = v1.split("").reverse()
          let i = 0
          var stop = 0
          if (v1.length / 3 >= 1 && v1.length % 3 != 0) {
            i = 1;
            stop = Math.trunc(v1.length / 3);
          }
          if (v1.length / 3 >= 1 && v1.length % 3 == 0) {
            i = 1;
            stop = Math.trunc(v1.length / 3) - 1
          }
          var pos = 3
          if (i >= 1) {
            for (i; i <= stop; i++) {
              v1.splice(pos, 0, ".");
              pos = pos + 4;
            }
          }
          numParsed = v1.reverse().join("") + ',' + v2
          if (numParsed.includes("-.")) {
            numParsed = numParsed.replace("-.", "-");
          }
          return numParsed
        }
        return "-"
      } catch (error) {
        return "-"
      }
    }
  },

  methods: {
    async loadRootNames() {
      const url = `${urlMainAPI}/getrootindicators/${this.unit}`;
      await axios.get(url)
        .then(res => {
          const indicators = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
          this.allRootNames = [...new Set(indicators.map(i => i.indicatorName).filter(Boolean))].sort();
        })
        .catch(e => {
          console.error('[loadRootNames] error:', e);
          this.allRootNames = [];
        });
    },

    async loadRootStates() {
      const url = `${urlMainAPI}/getarearootsstate/${this.unit}`;
      await axios.get(url)
        .then(res => {
          const states = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
          const map = {};
          if (Array.isArray(states)) {
            states.forEach(s => { if (s.indicatorName) map[s.indicatorName] = s; });
          }
          this.rootStates = map;
        })
        .catch(e => {
          console.error('[loadRootStates] error:', e);
        });
    },

    generateGhostHeaders() {
      const cols = this.colsNumber['lg'] || 7;
      const saved = this.savedHeaders;

      if (saved.length > 0 && 'isGhost' in saved[0]) {
        this.ghostHeaders = saved.map(h => ({ areaName: h.areaName, w: h.w, isGhost: h.isGhost }));
      } else if (saved.length > 0) {
        this.ghostHeaders = saved.map(h => ({ areaName: h.areaName, w: h.w, isGhost: false }));
        const usedCols = saved.reduce((sum, h) => sum + h.w, 0);
        const remaining = cols - usedCols;
        for (let i = 0; i < remaining; i++) {
          this.ghostHeaders.push({ areaName: '', w: 1, isGhost: true });
        }
      } else {
        this.ghostHeaders = Array.from({ length: cols }, () => ({
          areaName: '',
          w: 1,
          isGhost: true,
        }));
      }
    },

    ghostStyle(w) {
      const xMargin = (this.layout2 &&
        this.layout2.gridMonitoringConfiguration &&
        this.layout2.gridMonitoringConfiguration.xMargin) || 10;
      return {
        width: `calc(${w} / ${this.colsNumber['lg']} * 100% - ${xMargin}px)`,
        margin: `0 ${xMargin / 2}px`,
      };
    },

    onAreaChange(ghost) {
      ghost.isGhost = false;
    },

    onWidthChange(ghost, idx) {
      ghost.isGhost = false;
      this.rebalanceGhosts(idx);
    },

    removeGhost(idx) {
      const removed = this.ghostHeaders[idx];
      const ghosts = Array.from({ length: removed.w }, () => ({ areaName: '', w: 1, isGhost: true }));
      this.ghostHeaders.splice(idx, 1, ...ghosts);
    },

    rebalanceGhosts(afterIdx) {
      const totalCols = this.colsNumber['lg'] || 7;
      const currentTotal = this.ghostHeaders.reduce((sum, g) => sum + g.w, 0);
      const diff = currentTotal - totalCols;

      if (diff === 0) return;

      if (diff > 0) {
        let excess = diff;
        // Procura ghosts depois do indice alterado
        let i = afterIdx + 1;
        while (excess > 0 && i < this.ghostHeaders.length) {
          if (this.ghostHeaders[i].isGhost) {
            if (this.ghostHeaders[i].w <= excess) {
              excess -= this.ghostHeaders[i].w;
              this.ghostHeaders.splice(i, 1);
            } else {
              this.ghostHeaders[i].w -= excess;
              excess = 0;
            }
          } else {
            i++;
          }
        }
        // Se ainda ha excesso, procura ghosts antes do indice alterado
        let j = afterIdx - 1;
        while (excess > 0 && j >= 0) {
          if (this.ghostHeaders[j].isGhost) {
            if (this.ghostHeaders[j].w <= excess) {
              excess -= this.ghostHeaders[j].w;
              this.ghostHeaders.splice(j, 1);
            } else {
              this.ghostHeaders[j].w -= excess;
              excess = 0;
            }
          }
          j--;
        }
      } else {
        let deficit = -diff;
        let insertIdx = afterIdx + 1;
        for (let j = 0; j < deficit; j++) {
          this.ghostHeaders.splice(insertIdx, 0, { areaName: '', w: 1, isGhost: true });
          insertIdx++;
        }
      }
    },

    maxColsForGhost(idx) {
      const totalCols = this.colsNumber['lg'] || 7;
      const usedByOthers = this.ghostHeaders
        .filter((g, i) => i !== idx && !g.isGhost)
        .reduce((sum, g) => sum + g.w, 0);
      return Math.max(1, totalCols - usedByOthers);
    },

    ghostAdherence(areaName) {
      if (!areaName) return '- %';
      const state = this.rootStates[areaName];
      if (!state || state.workshiftBIndicatorReability == null) return '- %';
      const num = parseFloat(String(state.workshiftBIndicatorReability).replace(',', '.'));
      if (isNaN(num)) return '- %';
      const rounded = Math.round(num * 100) / 100;
      const formatted = (rounded % 1 !== 0 ? rounded.toFixed(2) : String(rounded)).replace('.', ',');
      return formatted + ' %';
    },

    ghostAlert(areaName) {
      if (!areaName) return false;
      const state = this.rootStates[areaName];
      return state ? state.alert : false;
    },

    getLayoutItem(indicatorName) {
      return this.layout.find(i => i.indicatorName === indicatorName) || null;
    },

    indicatorHeaderClasses(areaName) {
      if (this.savedHeaderConfigOption === 'indicators' && areaName) {
        const item = this.getLayoutItem(areaName);
        const isCard = true;
        if (!item) return { 'ghost-header-display--card': isCard };
        const isNeutral = item.lowerLimit === '-' && item.upperLimit === '-';
        return {
          'ghost-header-display--card': isCard,
          'ghost-header-display--alert': !isNeutral && item.alert,
          'ghost-header-display--neutral': isNeutral,
        };
      }
      return { 'ghost-header-display--alert': this.ghostAlert(areaName) };
    },

    async saveHeaderConfig() {
      if (this.headerConfigOption !== this.savedHeaderConfigOption) {
        const cols = this.colsNumber['lg'] || 7;
        this.ghostHeaders = Array.from({ length: cols }, () => ({ areaName: '', w: 1, isGhost: true }));
        this.savedHeaderConfigOption = this.headerConfigOption;
        if (this.layout2 && this.layout2.gridMonitoringConfiguration) {
          const emptyData = JSON.stringify({ type: this.headerConfigOption, items: [] });
          this.$set(this.layout2.gridMonitoringConfiguration, 'areaHeadersConfig', emptyData);
        }
        await this.SaveAreaHeaders();
      }
      this.$bvModal.hide('headerConfigModal');
    },

    cancelHeaderConfig() {
      this.headerConfigOption = this.savedHeaderConfigOption;
      this.$bvModal.hide('headerConfigModal');
    },

    async loadGridMonitoring() {
      if (this.editorMode) { return }
      const requestedUnit = this.unit;
      this.isReady = false;
      try {
        const url = `${urlMainAPI}/getindicatormonitoringlist/${requestedUnit}`;
        await axios
          .get(url)
          .then((res) => {
            if (this.unit !== requestedUnit) return;
            if (this.canShowFooter && res.data && res.data.gridMonitoringConfiguration) {
              this.layout = res.data.indicatorMonitoringGroup;
              this.layout2 = res.data;

              if (this.layout2.gridMonitoringConfiguration.qtyColumns != 0 && this.layout2.gridMonitoringConfiguration.qtyColumns < 20)
                this.colsNumber["lg"] = (this.layout2.gridMonitoringConfiguration.qtyColumns);

              this.gridId = res.data.gridMonitoringConfiguration.id;
              const rawConfig = res.data.gridMonitoringConfiguration.areaHeadersConfig;
              if (rawConfig) {
                try {
                  const parsed = JSON.parse(rawConfig);
                  if (parsed && !Array.isArray(parsed) && parsed.type) {
                    this.savedHeaderConfigOption = parsed.type;
                    this.headerConfigOption = parsed.type;
                  }
                } catch { /* mantém valor atual */ }
              }
              this.reliability.pgdi = res.data.gridMonitoringConfiguration.cardType == "PGDI" ? true : false;
              this.reliability.a = res.data.workshiftAReability;
              this.reliability.b = res.data.workshiftBReability;
              this.reliability.c = res.data.workshiftCReability;
              this.reliability.daily = res.data.dailyReability;
              this.reliability.a_name = res.data.workshiftAName || 'A';
              this.reliability.b_name = res.data.workshiftBName || 'B';
              this.reliability.c_name = res.data.workshiftCName || 'C';
              this.reliability.gridOn = true;
              this.footerBaseMsg = `${this.unit.split("-")[0]} - ÚLTIMA ATUALIZAÇÃO: ${this.dateBR(this.layout2.timestamp)}`;
              this.applyFooterMsg();
              this.$store.commit("setMsg2", this.reliability);
              const indicatorsMap = {};
              res.data.indicatorMonitoringGroup.forEach(i => { if (i.indicatorName) indicatorsMap[i.indicatorName] = i; });
              this.$store.commit("setIndicatorsData", indicatorsMap);
              this.$store.commit("setMonitoringGridId", res.data.gridMonitoringConfiguration.id);
              this.$store.commit("setFixedIndicatorsConfig", res.data.gridMonitoringConfiguration.fixedIndicatorsConfig || null);
              this.loadRootStates();

              // coloca no log o tempo atual
              console.log(">>-> Carregando a tela de monitoramento:", new Date().toLocaleString());
              task = setTimeout(() => {
                this.loadGridMonitoring();
              }, this.minutesMonitoring);
            }
          })
          .catch();
        this.isReady = true;
      } catch (error) {
        console.log("Erro na tela de monitoramento: " + error)
      }
    },

    async ChangeEditMode() {
      this.editorMode = !this.editorMode
      this.$store.commit('setMonitoringEditorMode', this.editorMode)
      if (this.editorMode) {
        clearTimeout(task);
        this.$store.commit("setMsg", `MODO DE EDIÇÃO ATIVADO`);
        this.$store.commit("setMsg2", null);
      }
      if (!this.editorMode) {
        this.$store.commit("setMsg", `MODO DE EDIÇÃO DESATIVADO`);
        this.$store.commit("setMsg2", null);
        await this.SaveGridPosition()
        let savedConfig = null;
        if (this.headerEditorMode) {
          savedConfig = await this.SaveAreaHeaders();
          this.headerEditorMode = false;
        }
        await this.loadGridMonitoring();
        if (savedConfig !== null && this.layout2 && this.layout2.gridMonitoringConfiguration) {
          this.$set(this.layout2.gridMonitoringConfiguration, 'areaHeadersConfig', savedConfig);
        }
      }
    },

    async SaveAreaHeaders() {
      const items = this.ghostHeaders.map(g => ({ areaName: g.areaName, w: g.w, isGhost: g.isGhost }));

      const serialized = JSON.stringify({ type: this.savedHeaderConfigOption, items });
      const url = `${urlMainAPI}/saveareaheaders/${this.gridId}`;
      let success = false;
      await axios
        .post(url, JSON.stringify(serialized), { headers: { 'Content-Type': 'application/json' } })
        .then(res => {
          defaultSuccess(res.data);
          success = true;
        })
        .catch(console.log);
      return success ? serialized : null;
    },

    async SaveGridPosition() {
      let cardPositionList = []
      this.layout.forEach(x => {
        let obj = {};
        obj.indicatorId = x.id
        obj.productionUnitId = x.productionUnitId
        obj.system = x.system
        obj.gridId = this.gridId
        obj.cardXPosition = x.x
        obj.cardYPosition = x.y
        obj.cardWidth = x.w
        obj.cardHeight = x.h
        obj.cardMinWidth = x.cardMinWidth
        obj.cardMinHeight = x.cardMinHeight
        obj.cardStatic = x.cardStatic

        cardPositionList.push(obj)
      })

      const url = `${urlMainAPI}/savecardposition`;
      await axios
        .post(url, cardPositionList)
        .then(res => {
          defaultSuccess(res.data);
        })
        .catch(console.log)
    },

    dateBR(date) {
      let dateBr = Date.parse(date);
      dateBr = new Date(dateBr);
      dateBr = dateBr.toLocaleString("pt-BR");
      let info = dateBr.split(" ")
      dateBr = info[0];
      let time = info[1].substring(0, 5)
      if (dateBr == "Invalid" || date == "1900-01-01 00:00:00") {
        return "Aguardando dados do servidor ";
      } else {
        return dateBr = dateBr + " " + time;
      }
    },

    applyFooterMsg(rotate = false) {
      if (!this.canShowFooter || this.editorMode) return;
      const messages = [];
      if (this.footerBaseMsg) messages.push(this.footerBaseMsg);
      if (this.footerOnlineMsg) messages.push(this.footerOnlineMsg);
      if (messages.length === 0) return;
      if (rotate) this.footerMsgIndex = (this.footerMsgIndex + 1) % messages.length;
      else this.footerMsgIndex = 0;
      this.$store.commit("setMsg", messages[this.footerMsgIndex]);
    },

    // Rotacao das MENSAGENS do rodape (nao confundir com a rotacao de TELAS do mixin)
    startFooterRotation() {
      this.stopFooterRotation();
      this.footerRotationInterval = setInterval(() => {
        this.applyFooterMsg(true);
      }, 10000);
    },

    stopFooterRotation() {
      if (this.footerRotationInterval) {
        clearInterval(this.footerRotationInterval);
        this.footerRotationInterval = null;
      }
    },

    async getSystemConfiguration() {
      const url = `${urlMainAPI}/getsystemconfiguration`;
      await axios.get(url)
        .then(res => {
          this.minutesMonitoring = res.data.onlineMonitoringInterval * 60000;
        })
        .catch(console.log);
    },
  },

  async created() {
    clearTimeout(task);
    await this.getSystemConfiguration();
    this.loadGridMonitoring();
    this.loadRootStates();
    this.startFooterRotation();
    this.startRotation();
  },

  beforeDestroy() {
    this.canShowFooter = false;
    this.$store.commit("setMsg", " ")
    this.$store.commit("setMsg2", { "reliability.pgdi": false, "reliability.a": 0, "reliability.b": 0, "reliability.c": 0, "reliability.daily": 0, "reliability.gridOn": false })
    this.$store.commit("setMonitoringEditorMode", false)
    clearTimeout(task);
    this.stopFooterRotation();
  }
}
</script>

<style scoped>
* {
  font-weight: 100;
}

.img-slot {
  display: flex;
  align-content: center;
  justify-content: center;
}

.waitTxt {
  display: flex;
  justify-content: center;
  background: black;
  color: white;
  margin-bottom: 10px;
}

#btLock {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 10;
  opacity: 0;
  background: transparent;
  border: 1px solid #fd7e14;
  color: #fd7e14;
  transition: opacity 300ms, background-color 200ms, color 200ms;
}

#btLock:hover {
  opacity: 1;
  background-color: #fd7e14;
  color: #fff;
}

.monitor-btn {
  background: transparent;
  border: 1px solid #fd7e14;
  color: #fd7e14;
  transition: background-color 200ms, color 200ms;
}

.monitor-btn:hover,
.monitor-btn:focus {
  background-color: #fd7e14;
  border-color: #fd7e14;
  color: #fff;
}

.header-row {
  display: flex;
  align-items: center;
  min-height: 48px;
  margin-bottom: 4px;
}

.header-row--editing {
  background: rgba(255, 255, 255, 0.5);
}


.header-actions {
  display: flex;
  gap: 4px;
  margin-bottom: 4px;
}

.ghost-header {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border: 2px solid #555;
  opacity: 0.55;
  min-width: 0;
}

.ghost-header--real {
  opacity: 1;
}

.ghost-header--spacer {
  border: none;
  opacity: 0;
}

.ghost-header-display {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgb(0, 0, 0);
  color: rgb(255, 255, 255);
  padding: 8px 8px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  flex: 1;
}

.ghost-header-display--alert {
  background: #d11e1d;
}

.ghost-header-display--neutral {
  background: #666666;
}

.ghost-header-display--card {
  display: block;
  padding: 0;
  white-space: normal;
  overflow: visible;
}

.ghost-area-name {
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 6px;
}

.ghost-adherence {
  flex-shrink: 0;
  color: #ddd;
}

.ghost-adherence--right {
  margin-left: auto;
}

.ghost-header-controls {
  display: flex;
  gap: 2px;
  padding: 2px;
  background: #2a2a2a;
}

.ghost-select {
  flex: 1;
  font-size: 11px;
  padding: 1px 2px;
  min-width: 0;
}

.ghost-select--cols {
  flex: 0 0 56px;
}

.ghost-btn-remove {
  flex-shrink: 0;
  padding: 1px 5px;
  font-size: 11px;
  line-height: 1.4;
}

.header-config-warning {
  color: #dc3545;
  font-weight: bold;
  text-align: center;
  border: 1px solid #dc3545;
  border-radius: 4px;
  padding: 6px 12px;
  margin-top: 12px;
  margin-bottom: 12px;
}

.header-config-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
}

@media only screen and (max-width: 1220px) {
  #btLock {
    display: none;
  }
}

@media only screen and (max-width: 800px) {

  .row3Col1,
  .row3Col2,
  .row3Col3,
  .row3Txt {
    font-weight: 400;
  }

  .row2Col1,
  .row2Col3 {
    font-weight: 400;
  }
}
</style>
